import { useMemo } from 'react';

import { useDestinationHealthStatus } from '@/features/workspace/hooks/use-destination-health-status';
import { useEmqHealthStatus } from '@/features/workspace/hooks/use-emq-health-status';
import { useEventHealthStatus } from '@/features/workspace/hooks/use-event-health-status';
import { useIntegrationHealthStatus } from '@/features/workspace/hooks/use-integration-health-status';
import { buildNavStatusSnapshot } from '@/features/workspace/helpers/nav-status';
import type { NavStatusSnapshot } from '@/lib/navigation/types/nav-types';
import { useUnreadCount } from '@/features/notifications/hooks/use-notifications';

export function useNavStatusSnapshot(): NavStatusSnapshot {
  const { status: integrationStatus, isLoading: integrationLoading } =
    useIntegrationHealthStatus();
  const { status: destinationStatus } = useDestinationHealthStatus();
  const { status: eventHealthStatus, isLoading: eventHealthLoading } =
    useEventHealthStatus();
  const { status: emqStatus, isLoading: emqLoading } = useEmqHealthStatus();
  const { data: unreadCount } = useUnreadCount();

  return useMemo(
    () =>
      buildNavStatusSnapshot({
        integrationStatus,
        integrationLoading,
        destinationStatus,
        eventHealthStatus,
        eventHealthLoading,
        emqStatus,
        emqLoading,
        unreadCount,
      }),
    [
      integrationStatus,
      integrationLoading,
      destinationStatus,
      eventHealthStatus,
      eventHealthLoading,
      emqStatus,
      emqLoading,
      unreadCount,
    ]
  );
}
